import { checkTaskStatusRpc, generateLayoutAsyncRpc } from '../../__generated__/chirp/com/hubspot/content/ai/editor/rpc/LayoutGeneration';
import { normalizeModuleFieldOverrides } from '../utils/gridsLayoutGenerationUtils';
import rpcClient from './RpcClient';

// These are FE-defined for now, the BE will accept any string for task
const TRY_ANOTHER_LAYOUT = 'Try another layout';
const APPLY_BRAND_VOICE = 'Apply brand voice';
export const Tasks = {
  TRY_ANOTHER_LAYOUT,
  APPLY_BRAND_VOICE
};
export const startLayoutGenerationTask = ({
  task,
  contentId,
  focusedNodeId,
  gridLayout
}) => {
  return rpcClient.call(generateLayoutAsyncRpc, {
    request: {
      task,
      contentId,
      focusedNodeId,
      gridLayout
    }
  });
};
export const fetchLayoutGenerationTask = taskId => {
  return rpcClient.call(checkTaskStatusRpc, {
    request: {
      taskId
    }
  });
};
export const getSectionFromAgentMessages = (agentMessages, targetSectionNodeId) => {
  var _gridLayoutChangeMess;
  if (!(agentMessages !== null && agentMessages !== void 0 && agentMessages.length)) {
    return undefined;
  }

  // Find relevant agent message:
  const gridLayoutChangeMessage = agentMessages.find(message => message.type === 'GRID_LAYOUT_CHANGE');
  const allSections = gridLayoutChangeMessage === null || gridLayoutChangeMessage === void 0 || (_gridLayoutChangeMess = gridLayoutChangeMessage.gridLayout) === null || _gridLayoutChangeMess === void 0 ? void 0 : _gridLayoutChangeMess.content;

  // Find the target section in the GridLayout:
  let generatedSection;
  let maybeNextSectionNodeId;
  if (allSections !== null && allSections !== void 0 && allSections.length) {
    for (let index = 0; index < allSections.length; index++) {
      const section = allSections[index];
      if (section.id === targetSectionNodeId) {
        generatedSection = section;
        // If possible, find the next immediate sibling section so we can use it for insertion coordinates
        maybeNextSectionNodeId = index + 1 < allSections.length ? allSections[index + 1].id : undefined;
        break;
      }
    }
  }
  if (!generatedSection) {
    return undefined;
  }
  const normalizedSection = Object.assign({}, generatedSection, {
    child: normalizeModuleFieldOverrides(generatedSection.child)
  });
  return {
    normalizedSection,
    nextSiblingSectionNodeId: maybeNextSectionNodeId
  };
};